import { render } from "./DbsDetailButtons.vue?vue&type=template&id=788b8d63&scoped=true"
import script from "./DbsDetailButtons.vue?vue&type=script&lang=js"
export * from "./DbsDetailButtons.vue?vue&type=script&lang=js"

import "./DbsDetailButtons.vue?vue&type=style&index=0&id=788b8d63&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-788b8d63"

export default script